import InfoList from 'components/InfoList/InfoList'
import { useRequisitionInfo } from 'hooks/drawers/useRequisitionInfo'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import { getNextAppointment } from 'controllers/TaskManager/controllers/utils'
import TaskRefusalController from 'controllers/TaskManager/TaskSubControllers/TaskRefusalController/TaskRefusalController'
import AlertBox from 'components/AlertBox/AlertBox'
import styles from '../../Requisition.module.sass'
import MedicalActsList from 'components/MedicalActsList/MedicalActsList'

const NonSurgicalRequisitionDetails = (props) => {
	const { requisition } = props
	const { i18n } = useGlobal()

	const {
		getSurgeryClinicalApprovalDetails,
		getAdmissionDetails,
		getMedicalActsListDetails,
	} = useRequisitionInfo(requisition, i18n)

	const nextAppointment = getNextAppointment(requisition?.appointments)
	const medicalActsListDetails = getMedicalActsListDetails()
	const isProcessInAnalysis = process.processInjuredStateId === 2

	return (
		<>
			<section>
				<TaskRefusalController requisition={requisition} />

				{/** 	{[2, 3].includes(requisition?.urgency?.id) && (
					<AlertBox
						className={styles['alert-box']}
						type='warning'
						items={[
							{
								title: requisition?.urgency?.description,
								text: i18n`Surgery must be performed soon`,
							},
						]}
					/>
				)}*/}

				{isProcessInAnalysis && (
					<AlertBox
						className={styles['alert-box']}
						type={'warning'}
						items={[
							{
								title: i18n`Warning`,
								text: i18n`The process is under review`,
							},
						]}
					/>
				)}
				{requisition?.clinicalObservation ? (
					<InfoList
						className={styles['info-list']}
						items={[
							{
								title: i18n`Medical observation`,
								text: requisition?.clinicalObservation,
								icon: 'observation',
							},
						]}
					/>
				) : null}

				{requisition?.administrativeObservation ? (
					<InfoList
						className={styles['info-list']}
						items={[
							{
								title: i18n`Administrative observation`,
								text: requisition?.administrativeObservation,
								icon: 'observation',
							},
						]}
					/>
				) : null}
			</section>

			<section>
				<InfoList
					items={getSurgeryClinicalApprovalDetails(nextAppointment)}
				/>
			</section>

			<section>
				<InfoList items={getAdmissionDetails()} />
			</section>

			{medicalActsListDetails.length ? (
				<section>
					<MedicalActsList
						items={medicalActsListDetails}
						title={i18n`Medical Acts`}
						subtitle={i18n`Laterality | Quantity`}
						displayListLength
					/>
				</section>
			) : null}
		</>
	)
}

export default NonSurgicalRequisitionDetails
